export const iconFontAwesomeHumanitarianVihara = (
	<i className="fa-solid fa-vihara"></i>
);
